import * as React from 'react';
import { Dropdown, Tab, Tabs, Image } from 'react-bootstrap';
import { connect } from 'react-redux';
import ReactTooltip from 'react-tooltip';
import { navigateTo } from '../../../../actions/navigationActions';
import { setIsOnQuoteScreen } from '../../../../actions/salesActions';
import { BANKING_DETAILS } from '../../../../routes/routes';
import AcceptQuote from '../../AcceptQuote/AcceptQuote';
import './WarrantyQuotation.css';

class WarrantyQuotation extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.handleAcceptQuote = this.handleAcceptQuote.bind(this);
    }

    async handleChange(e: any) {
        let name = e.target.name;
        let value = e.target.value;
        await this.setState({ [name]: value });
    }

    async handleAcceptQuote(e: any) {
        this.props.dispatchAction(setIsOnQuoteScreen(false, "", ""));
        this.props.dispatchAction(navigateTo(BANKING_DETAILS))
    }

    public render() {
        let coveredBenefits = <div></div>;
        let nonCoveredBenefits = <div></div>;
        if (this.props.sales.warrantyBenefits !== []) {
            coveredBenefits = this.props.sales.warrantyBenefits.filter(x => x.description !== "No Cover").map((item) => {
                return <div className="form-group row noma">
                    <p className="col-7 col-form-label">{item.benefitName}</p>
                    <p className="additional-cover-sub-header col-5 col-form-label text-right warranty-covered">{item.description}</p>
                </div>
            })

            nonCoveredBenefits = this.props.sales.warrantyBenefits.filter(x => x.description === "No Cover").map((item) => {
                return <div className="form-group row noma">
                    <p className="col-7 col-form-label">{item.benefitName}</p>
                    <p className="additional-cover-sub-header col-5 col-form-label text-right warranty-notcovered">{item.description}</p>
                </div>
            })
        }

        return (
            <div>
                <div className={this.props.auth.loggedIn ? "pt-lg-5 p-lg-0 logged-in" : "pt-lg-5 p-lg-0 logged-out"}>
                    <div className="container pt-3 pt-lg-0">
                        <div className="row justify-content-center QuoteDetails">
                            <div className="col-lg-6 col-12 pt-lg-3 pt-0 pb-lg-0 pb-3 mr-lg-4">
                                <h3 className="Comprehensive-car mb-1">Warranty cover</h3>
                                <p className="Comprehensive-details">{this.props.sales.vehicleYear} {this.props.sales.vehicleFullDescription}</p>
                                <p className="Comprehensive-details">Reg no. <b>{this.props.sales.regNr}</b></p>
                            </div>
                            <div className="border-lg-right border-sm-bottom"></div>
                            <div className="col-lg-4 col-md-6 col-12 pt-lg-0 pt-3 mx-auto">
                                <p className="Comprehensive-monthly-premium mb-1 text-center">This month’s premium</p>
                                <p className="Comprehensive-total">{this.props.profile.currencySymbol} {this.props.sales.carPremium}</p>
                                <div className="text-center">
                                    <button className="btn btn-solid-green w-100" id='acceptQuoteTop' onClick={this.handleAcceptQuote}>{this.props.sales.isNewItem ? "Add to quote" : "Update quote"}</button>
                                </div>
                            </div>
                        </div>

                        <div className="justify-content-center">
                            <div className="mt-3" id="WarrantySummary">
                                <Tabs defaultActiveKey="home" id="uncontrolled-tab-example">
                                    <Tab eventKey="home" title="Overview" className="mb-4">
                                        <div className="justify-content-center mt-3">
                                            <div>
                                                <div className="warranty-overview">
                                                    <div className="row">
                                                        <div className="col-lg-6 col-12">
                                                            <p className="productSummary-title mt-lg-3">Excess amount<img className="raftooltip ml-10px" id="rafTooltip" alt="" src="./images/icons-line-style-info-32-px.svg" data-for="excessWarrantyTooltip" data-tip="" />
                                                                <ReactTooltip id="excessWarrantyTooltip" className="tooltip-gray" place="right" effect="solid" backgroundColor="#3a1826" delayShow={1000}>An excess is payable by you, to your insurer, in the event of a claim</ReactTooltip>
                                                            </p>
                                                        </div>
                                                        <div className="col-lg-6 col-12">
                                                            <Dropdown className="fit-full">
                                                                <Dropdown.Toggle id="warranty-dropdown-excess" disabled>
                                                                    <div className="row">
                                                                        <div className="col-10">
                                                                            {this.props.profile.currencySymbol} 500
                                                                        </div>
                                                                    </div>
                                                                </Dropdown.Toggle>
                                                            </Dropdown>
                                                        </div>
                                                    </div>
                                                    <p><b>Please note:</b> For certain claims and circumstances, an additional excess may apply. Check your policy schedule for more info.</p>
                                                    <hr />
                                                    <div className="form-group row noma">
                                                        <p className="col-7 col-form-label">Car value<img className="raftooltip ml-10px" id="rafTooltip" alt="" src="./images/icons-line-style-info-32-px.svg" data-for="carValueTooltip" data-tip="" />
                                                            <ReactTooltip id="carValueTooltip" className="tooltip-gray" place="right" effect="solid" backgroundColor="#3a1826" delayShow={1000}>This is your car's retail value, based on the Auto Dealers' Guide</ReactTooltip>
                                                        </p>
                                                        <p className="additional-cover-sub-header col-5 col-form-label text-right">{this.props.sales.carWarrantyValueDisplay}</p>
                                                    </div>
                                                    <div className="form-group row noma">
                                                        <p className="col-7 col-form-label">Max mileage</p>
                                                        <p className="additional-cover-sub-header col-5 col-form-label text-right">{this.props.sales.carWarrantyMaxMilage}</p>
                                                    </div>
                                                    {coveredBenefits}
                                                </div>
                                                <div className="warranty-waiting-period mb-15px">
                                                    <p className="warranty-waiting-period-text"><b>Waiting period</b></p>
                                                    <div className="text-center">
                                                        <Image className="mb-30px" src='Images/OnlineQuotation/Warranty/WarrantyInfoBlock.svg' alt="" />
                                                    </div>
                                                    <p className="warranty-waiting-text">The first 30 days of cover (and pre-existing damage): <b>There’s no cover.</b><br /> <br />                                                       The first 30 to 60 days of cover:
                                                        You’re <b>covered for up to 25%</b> of the cost of the repairs or sum insured. Whichever is less.</p>
                                                </div>
                                                <p className="Overview-only-Pleas">Overview only. Please refer to our <a target="_blank" href="/Content/documents/King-price-insurance-policy.pdf">KPPD</a> and your policy schedule for more info.</p>
                                            </div>
                                        </div>
                                    </Tab>
                                    <Tab eventKey="notcovered" title="What’s not covered" className="mb-4">
                                        <div className="justify-content-center mt-3">
                                            <div className="Nutshell">
                                                <h3 className="covered-title text-center mb-1">What's not covered</h3>
                                                <p className="mb-0 text-center">Here's what you're not covered for:</p>
                                            </div>
                                            <div className="justify-content-center mt-3">
                                                <div className="warranty-overview mb-15px">
                                                    {nonCoveredBenefits}
                                                </div>
                                                <p className="Overview-only-Pleas">Overview only. Please refer to our <a target="_blank" href="/Content/documents/King-price-insurance-policy.pdf">KPPD</a> and your policy schedule for more info.</p>
                                            </div>
                                        </div>
                                    </Tab>
                                </Tabs>
                            </div>
                        </div>
                        <div className="row justify-content-center mt-3">
                            <div className="col-12">
                                <div className="text-center">
                                    <button className="btn btn-solid-green" id="AddToQuote" onClick={this.handleAcceptQuote}><span className="Add-to-quote">{this.props.sales.isNewItem ? "Add to quote" : "Update quote"}</span> <br /> <span className="QuoteTotal">{this.props.profile.currencySymbol} {this.props.sales.carPremium} pm</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <AcceptQuote premuim={this.props.sales.carPremium} />
            </div >
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        sales: state.sales,
        auth: state.firebase.auth,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchAction: (e) => dispatch(e)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(WarrantyQuotation);
